import { render } from "./userUpgrade.vue?vue&type=template&id=72504faf&scoped=true"
import script from "./userUpgrade.vue?vue&type=script&lang=js"
export * from "./userUpgrade.vue?vue&type=script&lang=js"

import "./userUpgrade.vue?vue&type=style&index=0&id=72504faf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72504faf"]])

export default __exports__